module.exports = __webpack_public_path__ + "static/img/school_logo.83b25ba8.jpg";